import React from 'react';

const StepCard = ({ step, index }) => {
  return (
    <div 
      className="relative text-center lg:text-left animate-fade-in-up"
      style={{ animationDelay: `${index * 150}ms` }}
    >
      {/* Step Number */}
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-sky-500/10 text-sky-500 text-2xl font-light mb-6">
        {String(step.step).padStart(2, '0')}
      </div>
      
      {/* Connector Line (hidden on mobile and last item) */}
      {index < 3 && (
        <div className="hidden lg:block absolute top-8 left-20 w-full h-px bg-gray-200 -z-10" />
      )}
      
      <h3 className="text-xl font-medium text-gray-900 mb-3">
        {step.title}
      </h3>
      <p className="text-gray-600 font-light leading-relaxed">
        {step.description}
      </p>
    </div>
  );
};

export default StepCard;
